export default function WhatsAppButton() {
  const message = encodeURIComponent(
    "Bonjour 😊\n\n" +
    "Je souhaite réserver pour le brunch.\n\n" +
    "📩 Informations de réservation :\n" +
    "• Jour souhaité : \n" +
    "• Service (si Sam/Dim : Service 1 (10h-12h) ou Service 2 (13h-15h)) : \n" +
    "• Nombre de personnes : \n" +
    "• Prénom : \n\n" +
    "Merci !"
  );

  return (
    <a
      href={`https://wa.me/262693527676?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-4 right-4 md:bottom-6 md:right-6 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center bg-[#25D366] text-white rounded-full shadow-2xl hover:scale-110 transition-all z-50 cursor-pointer animate-pulse-slow"
      aria-label="Contacter via WhatsApp"
    >
      <i className="ri-whatsapp-line text-2xl md:text-3xl"></i>
      
      <style>{`
        @keyframes pulse-slow {
          0%, 100% {
            transform: scale(1);
            box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7);
          }
          50% {
            transform: scale(1.05);
            box-shadow: 0 0 0 10px rgba(37, 211, 102, 0);
          }
        }
        .animate-pulse-slow {
          animation: pulse-slow 2s ease-in-out infinite;
        }
      `}</style>
    </a>
  );
}